import React, { useState, useEffect, useRef, useMemo } from 'react';

// Inline SVG components remain the same
const CloseIcon = ({ size = 24, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const UploadIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);

const FileIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
  </svg>
);

const TrashIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);

const MaximizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
  </svg>
);

const MinimizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
  </svg>
);

const NegativeInventoryIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 7h-9"></path>
    <path d="M20 17h-9"></path>
    <path d="M13.5 3.5L9 9l4.5 5.5"></path>
    <path d="M3 13h4"></path>
    <path d="M3 17h4"></path>
  </svg>
);

const BatchIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="9" x2="15" y2="9"></line>
    <line x1="9" y1="15" x2="15" y2="15"></line>
  </svg>
);

const BOMIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7L12 12L22 7L12 2Z"></path>
    <path d="M2 17L12 22L22 17"></path>
    <path d="M2 12L12 17L22 12"></path>
  </svg>
);

const ProductionIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
  </svg>
);

const PackingIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" y1="22.08" x2="12" y2="12"></line>
  </svg>
);

const SerialIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);

const API_URL = '/api';

const SearchableDropdown = ({ 
  options, 
  value, 
  onChange, 
  placeholder = "Select",
  error = false,
  width = "w-full",
  getOptionLabel = (option) => option.name || option.label || option.toString(),
  getOptionValue = (option) => option.value || option.id || option.toString(),
  getOptionSecondaryLabel = (option) => option.code || option.id || "",
  disabled = false,
  className = "",
  onMultiSelectTrigger = null,
  multiSelectShortcut = null
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const dropdownListRef = useRef(null);
  const searchInputRef = useRef(null);

  // Update dropdown position when opened
  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom,
        left: rect.left,
        width: rect.width
      });
    }
  }, [isOpen]);

  // Handle window resize and scroll to update position
  useEffect(() => {
    if (!isOpen) return;
    
    const handleUpdatePosition = () => {
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width
        });
      }
    };
    
    window.addEventListener('resize', handleUpdatePosition);
    window.addEventListener('scroll', handleUpdatePosition);
    
    return () => {
      window.removeEventListener('resize', handleUpdatePosition);
      window.removeEventListener('scroll', handleUpdatePosition);
    };
  }, [isOpen]);

  // Scroll highlighted item into view
  useEffect(() => {
    if (isOpen && dropdownListRef.current && highlightedIndex >= 0) {
      const items = dropdownListRef.current.querySelectorAll('.dropdown-item');
      if (items[highlightedIndex]) {
        items[highlightedIndex].scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }
  }, [highlightedIndex, isOpen]);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      // Clear search term and reset highlighted index when opening
      setSearchTerm('');
      setHighlightedIndex(-1);
      
      // Focus the search input after a short delay to ensure it's rendered
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 0);
    }
  }, [isOpen]);

  // Filter options based on search term
  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options;
    const term = searchTerm.toLowerCase();
    
    return options.filter(option => {
      const label = getOptionLabel(option).toLowerCase();
      const secondaryLabel = getOptionSecondaryLabel(option).toLowerCase();
      
      return label.includes(term) || secondaryLabel.includes(term);
    });
  }, [options, searchTerm, getOptionLabel, getOptionSecondaryLabel]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    // Check for multi-select shortcut
    if (onMultiSelectTrigger && multiSelectShortcut && e.ctrlKey && e.key === multiSelectShortcut) {
      e.preventDefault();
      onMultiSelectTrigger();
      return;
    }

    if (!isOpen) {
      if (e.key === 'ArrowDown' || e.key === 'Enter') {
        setIsOpen(true);
        return;
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex(prev => {
          if (prev < filteredOptions.length - 1) {
            return prev + 1;
          } else if (filteredOptions.length > 0) {
            return 0; // Loop back to first item
          }
          return prev;
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex(prev => {
          if (prev > 0) {
            return prev - 1;
          } else if (filteredOptions.length > 0) {
            return filteredOptions.length - 1; // Loop to last item
          }
          return prev;
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
          handleSelectOption(filteredOptions[highlightedIndex]);
        }
        break;
      case 'Escape':
        setIsOpen(false);
        break;
      default:
        break;
    }
  };

  const handleSelectOption = (option) => {
    onChange(getOptionValue(option));
    setIsOpen(false);
    setSearchTerm('');
    setHighlightedIndex(-1);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get selected option
  const selectedOption = options.find(option => getOptionValue(option) === value);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <div
        className={`${width} border rounded-lg px-3 py-2 cursor-pointer flex justify-between items-center ${
          error ? 'border-red-400' : 'border-[#E2E8F0]'
        } ${isOpen ? 'ring-1 ring-[#BDDDFC]' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        ref={triggerRef}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <span className="truncate">
          {selectedOption ? getOptionLabel(selectedOption) : placeholder}
        </span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      
      {isOpen && (
        <div 
          className="fixed z-[9999] bg-white border border-[#E2E8F0] rounded-lg shadow-lg"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            width: `${position.width}px`,
          }}
        >
          <div className="p-2 border-b border-[#E2E8F0]">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search..."
              className="w-full px-2 py-1 border border-[#E2E8F0] rounded focus:outline-none focus:ring-1 focus:ring-[#BDDDFC]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
          
          <div 
            className="max-h-60 overflow-y-auto" 
            ref={dropdownListRef}
          >
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={getOptionValue(option)}
                  className={`dropdown-item px-3 py-2 cursor-pointer hover:bg-[#F1F5F9] ${
                    highlightedIndex === index ? 'bg-[#BDDDFC]' : ''
                  } ${value === getOptionValue(option) ? 'bg-[#E6F0FF]' : ''}`}
                  onClick={() => handleSelectOption(option)}
                  onMouseEnter={() => setHighlightedIndex(index)}
                >
                  <div className="font-medium">{getOptionLabel(option)}</div>
                  {getOptionSecondaryLabel(option) && (
                    <div className="text-xs text-gray-500">{getOptionSecondaryLabel(option)}</div>
                  )}
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-gray-500">No options found</div>
            )}
          </div>
        </div>
      )}
      
      {error && <span className="text-xs text-red-500">*</span>}
    </div>
  );
};

const initialFields = {
  product_code: '', 
  product_name: '', 
  product_category_id: '', 
  uom_id: '', 
  status: 'Active',
  description: '', 
  product_image: null,
  BranchCode: '',
  department_id: '',
  allow_product_negative_inventory: 'No',
  allow_product_tracking: '', // Empty string for required selection
  // Production BOM fields
  production_bom_type: 'production BOM',
  production_bom_id: '',
  // Packing BOM fields
  packing_bom_type: 'packing BOM',
  packing_bom_id: '',
  // Shared fields for both BOM types
  manufacturing_policy: '',
  flush_method: '',
  // Product type
  product_type: ''
};

const ProductFormModal = ({ open, onClose, onSubmit, initialData, isEdit, loading }) => {
  const [fields, setFields] = useState({ ...initialFields, product_code: 'Loading...' });
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [isLoadingUoms, setIsLoadingUoms] = useState(true);
  const [filePreview, setFilePreview] = useState({});
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isUserValid, setIsUserValid] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loadingBranches, setLoadingBranches] = useState(true);
  
  // Department-related state
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [screenConfig, setScreenConfig] = useState(null);
  const [showDepartmentField, setShowDepartmentField] = useState(false);
  
  // BOM-related state
  const [productionBomHeaders, setProductionBomHeaders] = useState([]);
  const [packingBomHeaders, setPackingBomHeaders] = useState([]);
  const [loadingProductionBomHeaders, setLoadingProductionBomHeaders] = useState(false);
  const [loadingPackingBomHeaders, setLoadingPackingBomHeaders] = useState(false);
  
  // Ref for the file input to reset it
  const imageInputRef = useRef(null);
  
  // Function to fetch current user
  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setIsUserValid(false);
        setAuthError('No token found. Please log in again.');
        return false;
      }
      const userRes = await fetch(`${API_URL}/current-user`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const userData = await userRes.json();
      
      if (userData.user && userData.user.UserID) {
        setCurrentUser(userData.user);
        setIsUserValid(true);
        setAuthError(null);
        return true;
      } else {
        setIsUserValid(false);
        setAuthError('User information not available. Please log in again.');
        return false;
      }
    } catch (error) {
      console.error('Error fetching current user:', error);
      setIsUserValid(false);
      setAuthError('Error fetching user information. Please refresh the page.');
      return false;
    }
  };
  
  // Function to fetch branches
  const fetchBranches = async () => {
    setLoadingBranches(true);
    try {
      const response = await fetch(`${API_URL}/branches`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error('Error fetching branches:', error);
    } finally {
      setLoadingBranches(false);
    }
  };
  
  // Function to fetch departments
  const fetchDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const response = await fetch(`${API_URL}/departments`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartments([]);
    } finally {
      setLoadingDepartments(false);
    }
  };
  
  // Function to fetch screen configuration
  const fetchScreenConfig = async () => {
    try {
      const response = await fetch(`${API_URL}/screens`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }});
      const data = await response.json();
      
      const productScreen = data.screens.find(screen => 
        screen.ScreenName.toLowerCase() === 'ProductMaster'.toLowerCase()
      );

      if (productScreen) {
        setScreenConfig(productScreen);
        const shouldShowDepartment = productScreen.ShowOnHeader === true;
        setShowDepartmentField(shouldShowDepartment);
        
        if (shouldShowDepartment) {
          fetchDepartments();
        }
      }
    } catch (error) {
      console.error('Error fetching screen configuration:', error);
      setShowDepartmentField(false);
    }
  };
  
  // Function to fetch BOM headers by type
const fetchBomHeadersByType = async (bomType, setHeaders, setLoading) => {
  setLoading(true);
  try {
    // ADD .trim() HERE – this is the real fix
    const cleanType = bomType.trim();
    const response = await fetch(
      `${API_URL}/bom/headers?type=${encodeURIComponent(cleanType)}`
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Always ensure it's an array
    setHeaders(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error(`Error fetching ${bomType} headers:`, error);
    setHeaders([]);
    alert(`Failed to load ${bomType}. Server returned 500. Check BOM types in database.`);
  } finally {
    setLoading(false);
  }
};
  
  // Toggle between maximized and normal size
  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };
  
  // Fetch categories
  useEffect(() => {
    setIsLoadingCategories(true);
    fetch(`${API_URL}/product-categories`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }})
      .then(res => res.json())
      .then(data => {
        setCategories(data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      })
      .finally(() => {
        setIsLoadingCategories(false);
      });
  }, []);
  
  // Fetch UOMs
  useEffect(() => {
    setIsLoadingUoms(true);
    fetch(`${API_URL}/uoms`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }})
      .then(res => res.json())
      .then(data => {
        setUoms(data);
      })
      .catch(error => {
        console.error('Error fetching UOMs:', error);
      })
      .finally(() => {
        setIsLoadingUoms(false);
      });
  }, []);
  
  // Fetch branches
  useEffect(() => {
    fetchBranches();
  }, []);
  
  // Fetch current user on mount
  useEffect(() => {
    fetchCurrentUser();
  }, []);
  
  // Fetch screen configuration when modal opens
  useEffect(() => {
    if (open) {
      fetchScreenConfig();
    }
  }, [open]);
  
  // Fetch BOM headers when modal opens
  useEffect(() => {
    if (open) {
      // Fetch production BOM headers
      fetchBomHeadersByType('production BOM'.trim(), setProductionBomHeaders, setLoadingProductionBomHeaders);
fetchBomHeadersByType('packing BOM'.trim(), setPackingBomHeaders, setLoadingPackingBomHeaders);
    } else {
      setProductionBomHeaders([]);
      setPackingBomHeaders([]);
    }
  }, [open]);
  
  // Reset form state on close
  useEffect(() => {
    if (!open) {
      setFields(initialFields);
      setErrors({});
      setFilePreview({});
      setLoadingDetails(false);
      setIsMaximized(false);
      setShowDepartmentField(false);
      setScreenConfig(null);
      setProductionBomHeaders([]);
      setPackingBomHeaders([]);
    }
  }, [open]);
  
  // Fetch product details or next code on open
  useEffect(() => {
    if (open) {
      fetchCurrentUser();
      fetchBranches();
      
      if (isEdit && initialData) {
        setLoadingDetails(true);
        fetch(`${API_URL}/products/${initialData}`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }})
          .then(res => res.json())
          .then(data => {
            const { CreatedBy, UpdatedBy, ...dataWithoutUserFields } = data;
            let allowNegativeInventory = 'No';
            if (dataWithoutUserFields.AllowProductNegativeInventory) {
              if (Array.isArray(dataWithoutUserFields.AllowProductNegativeInventory)) {
                allowNegativeInventory = dataWithoutUserFields.AllowProductNegativeInventory[0] ? 'Yes' : 'No';
              } else {
                allowNegativeInventory = dataWithoutUserFields.AllowProductNegativeInventory ? 'Yes' : 'No';
              }
            }
            
            // Get the product tracking value (0, 1, or 2)
            let allowProductTracking = '';
            if (dataWithoutUserFields.AllowProductTracking !== undefined && dataWithoutUserFields.AllowProductTracking !== null) {
              allowProductTracking = parseInt(dataWithoutUserFields.AllowProductTracking);
            }
            
            // Use the manufacturing policy from production BOM (or packing if production is not set)
            const manufacturingPolicy = dataWithoutUserFields.ProductionManufacturingPolicy || 
                                      dataWithoutUserFields.PackingManufacturingPolicy || '';
            
            // Use the flush method from production BOM (or packing if production is not set)
            const flushMethod = dataWithoutUserFields.ProductionFlushMethod || 
                               dataWithoutUserFields.PackingFlushMethod || '';

                               const departmentId = dataWithoutUserFields.DepartmentID || dataWithoutUserFields.department_id || '';
          console.log('Setting department_id to:', departmentId, typeof departmentId);
            
            setFields({
              product_code: dataWithoutUserFields.ProductCode || '',
              product_name: dataWithoutUserFields.ProductName || '',
              product_category_id: dataWithoutUserFields.ProductCategoryID || '',
              uom_id: dataWithoutUserFields.UOMID || '',
              status: dataWithoutUserFields.Status || 'Active',
              description: dataWithoutUserFields.Description || '',
              product_image: null,
              BranchCode: dataWithoutUserFields.BranchCode || '',
              department_id: departmentId.toString(),
              allow_product_negative_inventory: allowNegativeInventory,
              allow_product_tracking: allowProductTracking,
              // Production BOM fields
              production_bom_type: dataWithoutUserFields.ProductionBOMType || 'production BOM',
              production_bom_id: dataWithoutUserFields.ProductionBOMID || '',
              // Packing BOM fields
              packing_bom_type: dataWithoutUserFields.PackingBOMType || 'packing BOM',
              packing_bom_id: dataWithoutUserFields.PackingBOMID || '',
              // Shared fields for both BOM types
              manufacturing_policy: manufacturingPolicy,
              flush_method: flushMethod,
              // Product type
              product_type: dataWithoutUserFields.ProductType || ''
            });
            setFilePreview({});
          })
          .catch(error => {
            console.error('Error fetching product details:', error);
          })
          .finally(() => {
            setLoadingDetails(false);
          });
      } else {
        setFields(prev => ({ ...initialFields, product_code: 'Loading...' }));
        fetch(`${API_URL}/productlatestcode`,{headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }})
          .then(res => res.json())
          .then(data => {
            setFields(prev => ({ ...prev, product_code: data.nextCode }));
          })
          .catch(error => {
            console.error('Error fetching latest product code:', error);
            setFields(prev => ({ ...prev, product_code: 'P-01' }));
          });
      }
      setErrors({});
    }
  }, [open, initialData, isEdit]);
  
  const handleChange = e => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };
  
  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setFields(prev => ({
        ...prev,
        [fieldName]: file
      }));
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: URL.createObjectURL(file)
      }));
    }
  };
  
  const handleFileRemove = (fieldName, inputRef) => {
    setFields(prev => ({
      ...prev,
      [fieldName]: null
    }));
    setFilePreview(prev => {
      const newPreviews = { ...prev };
      delete newPreviews[fieldName];
      return newPreviews;
    });
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  
  const validate = () => {
    const errs = {};
    if (!fields.product_name) errs.product_name = 'Required';
    if (!fields.product_category_id) errs.product_category_id = 'Required';
    if (!fields.uom_id) errs.uom_id = 'Required';
    if (!fields.status) errs.status = 'Required';
    if (!fields.BranchCode) errs.BranchCode = 'Required';
    if (showDepartmentField && !fields.department_id) errs.department_id = 'Required';
    
    // Validate product tracking - must be selected (0, 1, or 2)
    if (fields.allow_product_tracking === '' || fields.allow_product_tracking === null || fields.allow_product_tracking === undefined) {
      errs.allow_product_tracking = 'Required: Please select a tracking type';
    }
    
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (isSubmitting || formLoading || loading) {
      console.log('Form submission already in progress, ignoring duplicate submission');
      return;
    }
    
    if (!validate()) return;
    
    if (!isUserValid || !currentUser || !currentUser.UserID) {
      alert(authError || 'User information not available. Please refresh the page and log in again.');
      return;
    }
    
    setIsSubmitting(true);
    setFormLoading(true);
    
    const formData = new FormData();
    
    // Add all fields to FormData
    Object.keys(fields).forEach(key => {
      if (key !== 'product_image' && 
          key !== 'created_by' && 
          key !== 'updated_by') {
        if (key !== 'department_id' || showDepartmentField) {
          if (key === 'allow_product_negative_inventory') {
            formData.append(key, fields[key] === 'Yes' ? '1' : '0');
          } else if (key === 'allow_product_tracking') {
            // Ensure the value is a number (0, 1, or 2)
            formData.append(key, parseInt(fields[key]) || 0);
          } else {
            // Don't add empty strings for manufacturing policy and flush method
            if ((key === 'manufacturing_policy' || key === 'flush_method') && !fields[key]) {
              // Skip these fields if they're empty
            } else {
              formData.append(key, fields[key]);
            }
          }
        }
      }
    });
    
    // Add the shared manufacturing policy and flush method to both production and packing fields
    // Only if they have values
    if (fields.manufacturing_policy) {
      formData.append('production_manufacturing_policy', fields.manufacturing_policy);
      formData.append('packing_manufacturing_policy', fields.manufacturing_policy);
    }
    
    if (fields.flush_method) {
      formData.append('production_flush_method', fields.flush_method);
      formData.append('packing_flush_method', fields.flush_method);
    }
    
    if (fields.product_image) {
      formData.append('product_image', fields.product_image);
    }
    
    const userId = parseInt(currentUser.UserID);
    
    if (isEdit) {
      formData.append('updated_by', userId);
    } else {
      formData.append('created_by', userId);
    }
    
    try {
      await onSubmit(formData);
      onClose();
    } catch (error) {
      console.error('Error saving product:', error);
      alert(error.message || 'An error occurred while saving the product');
    } finally {
      setFormLoading(false);
      setIsSubmitting(false);
    }
  };
  
  if (!open) return null;
  
  if (loadingDetails) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <span className="text-[#2b6777] text-lg font-semibold">Loading...</span>
        </div>
      </div>
    );
  }
  
  // Check if product tracking is set to Batch or Serial (1 or 2)
  const isTrackingSet = isEdit && (fields.allow_product_tracking === 1 || fields.allow_product_tracking === 2);
  
  return (
    <div className={`fixed inset-0 z-50 flex justify-center transition-all duration-300 ease-in-out ${open ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
      <style>
        {`
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 8px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          .uppercase-input {
            text-transform: uppercase;
          }
          .disabled-warning {
            background-color: #fef3c7;
            border-color: #fcd34d;
          }
          .required-field {
            position: relative;
          }
          .required-field::after {
            content: "*";
            position: absolute;
            top: 0;
            right: -8px;
            color: #ef4444;
            font-weight: bold;
          }
        `}
      </style>
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
      <div className={`bg-white shadow-2xl h-full flex flex-col transition-transform transform-gpu duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'} ${isMaximized ? 'w-full max-w-full' : 'w-full max-w-6xl'}`}>
        <div className="flex-shrink-0 p-8 pb-6">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-[#384959]">{isEdit ? 'Edit Product' : 'Create New Product'}</h2>
            <div className="flex items-center gap-2">
              <button className="text-[#A0AEC0] hover:text-[#384959] transition-colors p-1" onClick={toggleMaximize} title={isMaximized ? "Restore" : "Maximize"}>
                {isMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
              </button>
              <button className="text-[#A0AEC0] hover:text-[#384959] transition-colors" onClick={onClose}>
                <CloseIcon />
              </button>
            </div>
          </div>
        </div>
        
        {open && !isUserValid && (
          <div className="mx-8 mb-4 bg-red-50 border-l-4 border-red-500 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  {authError || 'User information not available. Please refresh the page and log in again.'}
                </p>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex-grow overflow-y-auto custom-scrollbar px-8">
          <form onSubmit={handleSubmit} className="space-y-6 pb-6">
            {/* Product Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <h3 className="text-lg font-semibold text-[#384959] mb-4">Product Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Product Code</label>
                  <input 
                    name="product_code" 
                    value={fields.product_code} 
                    readOnly 
                    className="w-full border rounded-lg px-3 py-2 bg-[#F1F5F9] text-[#64748b] border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase-input" 
                  />
                </div>
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Product Name *</label>
                  <input 
                    name="product_name" 
                    autoComplete="off"
                    value={fields.product_name} 
                    onChange={handleChange} 
                    className={`w-full border rounded-lg px-3 py-2 ${errors.product_name ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`}  
                    style={{ textTransform: "uppercase" }}
                  />
                  {errors.product_name && <span className="text-xs text-red-500">{errors.product_name}</span>}
                </div>
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Product Type</label>
                   <SearchableDropdown
                    options={[
                      { value: 'raw material', label: 'Raw Material' },
                      { value: 'semi-finished', label: 'Semi-Finished' },
                      { value: 'finished goods', label: 'Finished Goods' },
                      { value: 'service item', label: 'Service Item' },
                      { value: 'non-inventory item', label: 'Non-Inventory Item' }
                    ]}
                    value={fields.product_type}
                    onChange={(value) => handleChange({ target: { name: 'product_type', value } })}
                    placeholder="Select Product Type"
                    className="uppercase"
                  />
                </div>
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Category *</label>
                  <SearchableDropdown
                    options={categories}
                    value={fields.product_category_id}
                    onChange={(value) => handleChange({ target: { name: 'product_category_id', value } })}
                    getOptionLabel={(category) => category.CategoryName}
                    getOptionValue={(category) => category.CategoryID}
                    placeholder={isLoadingCategories ? 'Loading categories...' : 'Select Category'}
                    error={errors.product_category_id}
                    disabled={isLoadingCategories}
                  />
                  {errors.product_category_id && <span className="text-xs text-red-500">{errors.product_category_id}</span>}
                </div>
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">UOM *</label>
                   <SearchableDropdown
                    options={uoms}
                    value={fields.uom_id}
                    onChange={(value) => handleChange({ target: { name: 'uom_id', value } })}
                    getOptionLabel={(uom) => uom.UOMName}
                    getOptionValue={(uom) => uom.UOMID}
                    placeholder={isLoadingUoms ? 'Loading UOMs...' : 'Select UOM'}
                    error={errors.uom_id}
                    disabled={isLoadingUoms}
                  />
                  {errors.uom_id && <span className="text-xs text-red-500">{errors.uom_id}</span>}
                </div>
                
                {showDepartmentField && (
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Department *</label>
                   <SearchableDropdown
                      options={departments}
                      value={fields.department_id}
                      onChange={(value) => handleChange({ target: { name: 'department_id', value } })}
                      getOptionLabel={(dept) => `${dept.DepartmentCode} - ${dept.DepartmentName}`}
                      getOptionValue={(dept) => dept.DepartmentID.toString()}
                      getOptionSecondaryLabel={(dept) => dept.DepartmentName}
                      placeholder={loadingDepartments ? 'Loading departments...' : 'Select Department'}
                      error={errors.department_id}
                      disabled={loadingDepartments}
                      className="uppercase"
                    />
                    {errors.department_id && <span className="text-xs text-red-500">{errors.department_id}</span>}
                  </div>
                )}

                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Branch *</label>
                  <SearchableDropdown
                    options={branches}
                    value={fields.BranchCode}
                    onChange={(value) => handleChange({ target: { name: 'BranchCode', value } })}
                    getOptionLabel={(branch) => `${branch.BranchCode} - ${branch.BranchName}`}
                    getOptionValue={(branch) => branch.BranchCode}
                    getOptionSecondaryLabel={(branch) => branch.BranchName}
                    placeholder={loadingBranches ? 'Loading branches...' : 'Select Branch'}
                    error={errors.BranchCode}
                    disabled={loadingBranches}
                    className="uppercase"
                  />
                  {errors.BranchCode && <span className="text-xs text-red-500">{errors.BranchCode}</span>}
                </div>
                
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b]">Status *</label>
                  <select 
                    name="status" 
                    value={fields.status} 
                    onChange={handleChange} 
                    className={`w-full border rounded-lg px-3 py-2 ${errors.status ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {errors.status && <span className="text-xs text-red-500">{errors.status}</span>}
                </div>
                
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b] flex items-center">
                    <NegativeInventoryIcon className="mr-2 text-[#6A89A7]" />
                    Allow Negative Inventory
                  </label>
                  <select 
                    name="allow_product_negative_inventory" 
                    value={fields.allow_product_negative_inventory} 
                    onChange={handleChange} 
                    className="w-full border rounded-lg px-3 py-2 border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]"
                  >
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                  <p className="text-xs text-[#64748b] mt-1">
                    Select "Yes" to allow the product inventory to go below zero.
                  </p>
                </div>
                
                <div className='flex flex-col gap-2'>
                  <label className="block text-sm font-medium text-[#64748b] flex items-center required-field">
                    <BatchIcon className="mr-2 text-[#6A89A7]" />
                    Product Tracking
                  </label>
                  <select 
                    name="allow_product_tracking" 
                    value={fields.allow_product_tracking} 
                    onChange={handleChange} 
                    className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] ${isTrackingSet ? 'disabled-warning cursor-not-allowed' : errors.allow_product_tracking ? 'border-red-400' : 'border-[#E2E8F0]'}`}
                    disabled={isTrackingSet}
                  >
                    <option value="">Select Tracking Type</option>
                    <option value={0}>None</option>
                    <option value={1}>Batch</option>
                    <option value={2}>Serial</option>
                  </select>
                  {errors.allow_product_tracking && <span className="text-xs text-red-500">{errors.allow_product_tracking}</span>}
                  <p className="text-xs text-[#64748b] mt-1">
                    {isTrackingSet 
                      ? "Tracking is set to Batch or Serial for this product and cannot be changed."
                      : "Please select a tracking type for this product. If you select None, you can change it later. If you select Batch or Serial, it cannot be changed after saving."
                    }
                  </p>
                </div>
              </div>
            </div>
            
            {/* BOM Information Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <h3 className="text-lg font-semibold text-[#384959] mb-4 flex items-center">
                <BOMIcon className="mr-2 text-[#6A89A7]" />
                BOM Information
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Production BOM */}
                <div className="space-y-4">
                  <div className="flex items-center">
                    <ProductionIcon className="mr-2 text-[#6A89A7]" />
                    <h4 className="text-md font-medium text-[#384959]">Production BOM</h4>
                  </div>
                  
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">BOM Header</label>
                     <SearchableDropdown
                      options={productionBomHeaders}
                      value={fields.production_bom_id}
                      onChange={(value) => handleChange({ target: { name: 'production_bom_id', value } })}
                      getOptionLabel={(header) => `${header.BOMName} (${header.BOMID})`}
                      getOptionValue={(header) => header.BOMID}
                      getOptionSecondaryLabel={(header) => header.BOMName}
                      placeholder={loadingProductionBomHeaders ? 'Loading...' : 'Select Production BOM Header'}
                      disabled={loadingProductionBomHeaders}
                    />
                  </div>
                </div>
                
                {/* Packing BOM */}
                <div className="space-y-4">
                  <div className="flex items-center">
                    <PackingIcon className="mr-2 text-[#6A89A7]" />
                    <h4 className="text-md font-medium text-[#384959]">Packing BOM</h4>
                  </div>
                  
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">BOM Header</label>
                    <select 
                      name="packing_bom_id" 
                      value={fields.packing_bom_id} 
                      onChange={handleChange} 
                      className="w-full border rounded-lg px-3 py-2 border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]"
                      disabled={loadingPackingBomHeaders}
                    >
                      <option value="">{loadingPackingBomHeaders ? 'Loading...' : 'Select Packing BOM Header'}</option>
                      {packingBomHeaders.map(header => (
                        <option key={header.BOMID} value={header.BOMID}>
                          {header.BOMName} ({header.BOMID})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              
              {/* Manufacturing and Flush Settings - Shared for both BOM types */}
              <div className="mt-6 pt-6 border-t border-[#E2E8F0]">
                <h4 className="text-md font-medium text-[#384959] mb-4">Manufacturing and Flush Settings</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Manufacturing Policy</label>
                    <select 
                      name="manufacturing_policy" 
                      value={fields.manufacturing_policy} 
                      onChange={handleChange} 
                      className="w-full border rounded-lg px-3 py-2 border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]"
                    >
                      <option value="">Select Manufacturing Policy</option>
                      <option value="made to order">Made to Order</option>
                      <option value="made to stock">Made to Stock</option>
                    </select>
                    <p className="text-xs text-[#64748b] mt-1">
                      This setting applies to both Production and Packing BOM
                    </p>
                  </div>

                  <div className='flex flex-col gap-2'>
                    <label className="block text-sm font-medium text-[#64748b]">Flush Method</label>
                    <select 
                      name="flush_method" 
                      value={fields.flush_method} 
                      onChange={handleChange} 
                      className="w-full border rounded-lg px-3 py-2 border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]"
                    >
                      <option value="">Select Flush Method</option>
                      <option value="manual">Manual</option>
                      <option value="forward">Forward</option>
                      <option value="backward">Backward</option>
                    </select>
                    <p className="text-xs text-[#64748b] mt-1">
                      This setting applies to both Production and Packing BOM
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Description Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <h3 className="text-lg font-semibold text-[#384959] mb-4">Description</h3>
              <div className='flex flex-col gap-2'>
                <label className="block text-sm font-medium text-[#64748b]">Short Description</label>
                <textarea 
                  name="description" 
                  rows="4"
                  value={fields.description} 
                  onChange={handleChange} 
                  className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase-input"
                />
              </div>
            </div>
            
            {/* Documents Section */}
            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
              <h3 className="text-lg font-semibold text-[#384959] mb-4">Documents</h3>
              <div className="flex flex-col gap-2">
                <label className="block text-sm font-medium text-[#64748b]">Product Image (Optional)</label>
                <div className="flex items-center gap-2">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'product_image')}
                    className="hidden"
                    id="product-image-upload"
                    ref={imageInputRef}
                  />
                  <label
                    htmlFor="product-image-upload"
                    className="flex items-center gap-2 px-4 py-2 bg-[#6A89A7] text-white rounded-lg cursor-pointer hover:bg-[#88BDF2] shadow transition-colors"
                  >
                    <UploadIcon /> Upload
                  </label>
                  {filePreview.product_image && (
                    <div className="flex items-center gap-2">
                      <img src={filePreview.product_image} alt="Product preview" className="w-10 h-10 object-cover rounded" />
                      <button
                        type="button"
                        onClick={() => handleFileRemove('product_image', imageInputRef)}
                        className="p-1 text-red-500 hover:text-red-700 transition-colors"
                      >
                        <TrashIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        
        <div className="flex-shrink-0 p-8 pt-0">
          <div className="flex justify-end gap-3">
            <button 
              type="button" 
              className="px-6 py-3 rounded-lg text-[#64748b] font-semibold transition-all duration-300 ease-in-out hover:bg-[#F1F5F9]" 
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              form="product-form"
              className="px-6 py-3 rounded-lg text-white font-semibold shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 bg-[#6A89A7] hover:bg-[#88BDF2] disabled:opacity-50 disabled:cursor-not-allowed" 
              disabled={loading || isSubmitting || formLoading || fields.product_code === 'Loading...' || !isUserValid}
              onClick={handleSubmit}
            >
              {formLoading || isSubmitting || loading ? 'Saving...' : (isEdit ? 'Update Product' : 'Create Product')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFormModal;